export default __webpack_public_path__ + "static/media/multiasset-banner-single.b6e44c6e.jpg";